export default {
  methods: {
    isEdge() {
      return window.navigator.userAgent.indexOf("Edge") > -1;
    }
  }
};
